import React, { useEffect, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { IProduct } from '../../../../../types/types';

export const itemPriceTemplate = (item: IProduct, showError: boolean, onChange: (item: IProduct) => void) => {
  const [input, setInput] = useState<string>(item.amount.toFixed(2));
  const minPrice = 0.00;
  const maxPrice = 1_000_000;
  const onInputChange = (value: string) => {
    const tempInput = value.replace(/[^0-9.]/g, '');
    const amount = Number(tempInput);

    if (amount >= minPrice && amount < maxPrice) {
      item.amount = amount;
      onChange(item);
      setInput(tempInput);
    }
  };
  useEffect(() => {
    setInput(item.amount.toFixed(2));
  }, [item]);
  const prefix = '$';

  return (
    <div className={`flex justify-center items-center h-[64px] ${showError ? 'border-[1px]  border-red02' : 'border-[0px] border-l-[0px]'} ${item.serviceItemId === undefined && 'hover:bg-bw02'}  `}>

      <CurrencyInput
        id='inputInvoiceItemPriceInput'
        name='input-price'
        className={`w-full text-center outline-none bg-transparent font-metricR text-[14px] ${item.serviceItemId === undefined ? 'text-bw08' : 'text-bw07'} ${item.serviceItemId === undefined ? 'hover:cursor-text' : 'hover:cursor-auto'}`}
        placeholder='$0.00'
        value={input}
        decimalsLimit={2}
        defaultValue={item.amount.toFixed(2)}
        disabled={item.serviceItemId !== undefined}
        prefix={prefix}
        allowNegativeValue={false}
        onValueChange={(value) => onInputChange((value || minPrice.toFixed(2)))}
        onBlur={() => onInputChange((Number(input)).toFixed(2))}
      />
    </div>
  );
};
